import { AIAlert } from '@procurify/ui'
import styled from 'styled-components'

export const AiActionBannerStyled = styled(AIAlert)`
  padding: ${(props) =>
    `${props.theme.space.small} ${props.theme.space.medium}`};

  border-radius: ${(props) => props.theme.typography.pxToRem(4)};

  color: ${(props) => props.theme.colors.alert.ai.content};
`
